import { render, staticRenderFns } from "./StatsCard.vue?vue&type=template&id=65391a42"
import script from "./StatsCard.vue?vue&type=script&lang=js"
export * from "./StatsCard.vue?vue&type=script&lang=js"
import style0 from "./StatsCard.vue?vue&type=style&index=0&id=65391a42&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65391a42')) {
      api.createRecord('65391a42', component.options)
    } else {
      api.reload('65391a42', component.options)
    }
    module.hot.accept("./StatsCard.vue?vue&type=template&id=65391a42", function () {
      api.rerender('65391a42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/material/StatsCard.vue"
export default component.exports